import React from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

const Header = () => (
	<div className="Header">
		<Link to="/" className="Logo">
			<h1>VG</h1>
		</Link>
		<nav className="Nav">
			<Link to="/work" className="Nav-Children">
				Work
			</Link>
			{/* <Link to="/photography" className="Nav-Children">
				Photography
			</Link> */}
			<Link to="/" className="Nav-Children">
				About
			</Link>
			<Link to="/contact" className="Nav-Children">
				<button className="btn btn-orange">Contact</button>
			</Link>
		</nav>
	</div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js